import { render, staticRenderFns } from "./AddCategories.vue?vue&type=template&id=751fc40a&scoped=true"
import script from "./AddCategories.vue?vue&type=script&lang=js"
export * from "./AddCategories.vue?vue&type=script&lang=js"
import style0 from "./AddCategories.vue?vue&type=style&index=0&id=751fc40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751fc40a",
  null
  
)

export default component.exports